export default __webpack_public_path__ + "static/blocks-dd00f5dbb70a27af543314b99554933d.mp4";